import { Box, HStack, Text } from "@chakra-ui/react";
import * as React from "react";

import {
  CHANGE_DOT_COLORS,
  changeDetail,
  changeLabel,
} from "../lib/linkedin-change";
import { LinkedinChange, LinkedinChangeKind } from "../types/linkedin";

export function ChangeDot({ kind }: { kind: LinkedinChangeKind }) {
  return (
    <Box
      background={CHANGE_DOT_COLORS[kind] as any}
      borderRadius="full"
      flexShrink="0"
      height="1.5"
      width="1.5"
    />
  );
}

export function ChangeCell({ change }: { change: LinkedinChange }) {
  return (
    <HStack gap="2" minWidth="0">
      <ChangeDot kind={change.kind} />
      <Text fontWeight="medium" whiteSpace="nowrap">
        {changeLabel(change)}
      </Text>
      <Text color="fg.muted" truncate>
        {changeDetail(change)}
      </Text>
    </HStack>
  );
}
